import { isEmpty } from "lodash";
import { useMemo } from "react";
import { ASSIGNED_SEATING, enums } from "@shared/constants";
import { useSeatingState } from "@shared/modules/seating/contexts/useSeatingState";
import { ItemSelectModalProps } from "./ItemSelectModal.props";

export function useItemSelectModal(props: ItemSelectModalProps) {
  const { itemsOnSeat } = props;
  const { $name, $permissions } = itemsOnSeat;
  const { seatingServiceState } = useSeatingState();

  const isSeat = useMemo(() => $name === ASSIGNED_SEATING.SEAT.ID, [$name]);
  const isLocation = useMemo(
    () => $name === ASSIGNED_SEATING.GENERAL_ADMISSION.ID,
    [$name]
  );

  /**
   * hasWaitlist
   * Used to determine whether or not to show the waitlist selection modal
   * Which shows the user packages/next-app/components/organisms/seating/modals/WaitlistSelectModal/WaitlistSelectModal.tsx
   *
   * In order for a seat to be waitlisted
   *
   * It needs to have a waitlist object on the item
   *
   * It needs to have no resale ID
   *
   * OR
   *
   * It needs to have a resale ID with a resale status of completed
   *
   * We do this so that completed waitlist/resales are not shown as unavailable
   */
  const hasWaitlist = useMemo(
    () =>
      !isEmpty($permissions) &&
      $permissions.every(
        (p) =>
          seatingServiceState?.itemTypeMap[
            p.seatingItemTypeId as keyof typeof seatingServiceState.itemTypeMap
          ].waitlist &&
          (p.seatingItemResaleId === null ||
            (p.seatingItemResaleId !== null &&
              p.seatingItemResaleStatus ===
                enums.RESALE_SUBMISSION_STATUS_MAP.COMPLETED.id))
      ),
    [$permissions, seatingServiceState]
  );

  return {
    isSeat,
    isLocation,
    hasWaitlist,
  };
}
